import React from 'react';
import {t} from 'lib/i18n';

interface IPlayPauseProps {
  onClickPlayPause: () => void;
  isPaused: boolean;
}

/**
 * 재생/정지 컴포넌트
 */

const PlayPause = ({onClickPlayPause, isPaused}: IPlayPauseProps) => {
  const cssObject = {
    cssClass: 'play',
    label: t('재생'),
  };

  if (!isPaused) {
    cssObject.cssClass = 'pause';
    cssObject.label = t('일시정지');
  }

  return (
    <button
      type='button'
      className={cssObject.cssClass}
      aria-label={cssObject.label}
      onClick={onClickPlayPause}></button>
  );
};

export default PlayPause;
